import { render } from "./NewTabLink.vue?vue&type=template&id=c4f4045c&ts=true"
import script from "./NewTabLink.vue?vue&type=script&lang=ts"
export * from "./NewTabLink.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__